export interface SummaryConfig {
    summaryGrouping: string;
    totalPrice: boolean;
    disclaimerText: string;
    sendSummaryCard: CardData;
    cards: CardData[];
}

export interface CardData {
    id: string;
    enabled: boolean;
    icon: string;
    title: string;
    description: string;
    buttonText: string;
    feedbackButtonText?: string;
    buttonAction?: string;
    buttonLink?: string;
    isBlueprintLink: boolean;
    sendBlueprintAssortmentIdAs?: { [key: string]: string };
    webshopUrl: string;
    emailSentDescription?: string;
    openInSameTab?: boolean;
    // Form fields for input-collecting cards (SEND_TO_SHOP, SEND_TO_PARENT).
    inputs?: InputData[];
}

export interface InputData {
    id: string;
    title: string;
    required: boolean;
    enabled?: boolean;
    /**
     * @deprecated Not read since NGOP-1499. The consumer summary copy is governed solely by the DS Web
     * Admin account setting (`AppCustomization.SendSummaryCopyToUserEnabled`) — see
     * `shouldSendSummaryEmail`. Still declared only because the key exists in live summary.json files
     * (e.g. Simpolo's), where it now has no effect; remove it from those, then remove this.
     */
    sendSummaryEmail?: boolean;
}

// Converts JSON strings to/from your types
export class Convert {
    public static toSummaryConfig(json: string): SummaryConfig {
        return JSON.parse(json);
    }

    public static summaryConfigToJson(value: SummaryConfig): string {
        return JSON.stringify(value);
    }
}
